/**
 * Hook de datos de la **métrica avanzada** del dashboard: efectividad de entregas
 * (`GET /api/v1/stats/effectiveness`).
 *
 * Datos de servidor -> TanStack Query. Se habilita con `enabled`: la pantalla
 * solo lo activa cuando el usuario tiene el permiso `advanced_stats` (paridad con
 * la sección "Análisis" del SSR), de modo que **no se pide** la métrica para
 * quien no debe verla. La query key se segmenta por sede activa, igual que los
 * KPIs principales.
 */
import { useQuery } from "@tanstack/react-query";

import { getActiveSedeId } from "@/lib/sede";

import { fetchEffectiveness } from "../api";
import type { EffectivenessStats } from "../types";

/** Query key de la efectividad de entregas, segmentada por sede activa. */
export function effectivenessQueryKey(sedeId: number | null) {
  return ["dashboard", "effectiveness", { sede: sedeId }] as const;
}

export function useEffectiveness(enabled: boolean) {
  const sedeId = getActiveSedeId();
  return useQuery<EffectivenessStats>({
    queryKey: effectivenessQueryKey(sedeId),
    queryFn: fetchEffectiveness,
    enabled,
    staleTime: 30_000,
  });
}
